import { useState } from "react";

// UI preference only (non-sensitive) — remembers that a banner was dismissed on this device.
export default function useLocalDismiss(key) {
  const k = `dismiss:${key}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(k) === "1");
  return [dismissed, () => { localStorage.setItem(k, "1"); setDismissed(true); }];
}
